import React from 'react'
import {
  TextInput,
  SimpleForm,
  required,
  Create,
  ImageInput,
  ImageField,
  useNotify,
  useRedirect,
  CreateProps,
  SelectInput,
} from 'react-admin'

import { Grid, Paper, Typography, makeStyles } from '@material-ui/core'
import { slugValidate } from 'utils/formValidations'

import { Tooltip } from 'components'

const useStyles = makeStyles({
  container: {
    width: '100%',
  },
  gridContainer: {
    width: '100%',
  },
  formContainer: {
    backgroundColor: '#F5F5F5',
  },
  paperContainer: {
    padding: 16,
  },
})

interface CustomCreateProps extends CreateProps {
  title: string
  showAside: boolean
  shouldRedirect: boolean
  closeDrawer: boolean
  onSubmitSuccess: () => void
  onSubmitFailure: (error: any) => void
  toolbar: React.ReactElement
  aside: React.ReactElement
  basePath: string
}

export const CreateForm = (props: CustomCreateProps) => {
  const redirect = useRedirect()
  const notify = useNotify()
  const classes = useStyles()
  const {
    shouldRedirect = true,
    onSubmitSuccess = () => {},
    onSubmitFailure = () => {},
    toolbar = <></>,
    aside = <></>,
    ...rest
  } = props

  const onSuccess = () => {
    notify('post_successfully')
    if (shouldRedirect) redirect(props.basePath)
    onSubmitSuccess()
  }

  const onFailure = (error: any) => {
    onSubmitFailure(error)
    notify('post_failed', 'warning')
  }

  return (
    <Create
      aside={aside}
      {...rest}
      onSuccess={onSuccess}
      onFailure={onFailure}
      className={classes.container}
    >
      <SimpleForm
        warnWhenUnsavedChanges
        className={classes.formContainer}
        toolbar={toolbar}
      >
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          spacing={2}
          className={classes.gridContainer}
        >
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Paper className={classes.paperContainer}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography variant="h5" color="textSecondary" gutterBottom>
                  {props.title}
                </Typography>
                <hr />
              </Grid>

              <Grid
                container
                spacing={2}
                className={classes.gridContainer}
                direction="column"
              >
                <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                  <Tooltip title={'images.type'}>
                    <SelectInput
                      fullWidth
                      label="Tipo"
                      source={'type'}
                      choices={[
                        { id: 'banner', name: 'banner' },
                        { id: 'banner-responsive', name: 'banner-responsive' },
                        { id: 'banner-mobile', name: 'banner-mobile' },
                        {
                          id: 'conclusion-exercise',
                          name: 'conclusion-exercise',
                        },
                        { id: 'logo', name: 'logo' },
                        { id: 'md-background', name: 'md-background' },
                        {
                          id: 'md-background-mobile',
                          name: 'md-background-mobile',
                        },
                        { id: 'poster', name: 'poster' },
                        { id: 'popup', name: 'popup' },
                      ]}
                      validate={[required('Obrigatório')]}
                    />
                  </Tooltip>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Tooltip title={'images.alt'}>
                    <TextInput
                      fullWidth
                      label="Alt"
                      source={'alt'}
                      validate={[required('Obrigatório')]}
                    />
                  </Tooltip>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Typography color="primary" gutterBottom>
                    Imagem
                  </Typography>
                  <Tooltip title={'images.path'}>
                    <ImageInput
                      source="files"
                      label="Utilize imagens já otimizadas para web. Formatos PNG e JPG."
                      accept="image/*"
                      placeholder={<p>Clique aqui ou arraste uma imagem</p>}
                      validate={[required('Obrigatório')]}
                    >
                      <ImageField source="src" title="title" />
                    </ImageInput>
                  </Tooltip>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <SelectInput
                    fullWidth
                    label="Tipo de imagem"
                    source="complementary_type"
                    choices={[
                      { id: 'banners', name: 'Banner' },
                      { id: 'logos', name: 'Logo' },
                      { id: 'posters', name: 'Poster' },
                      { id: 'avatars', name: 'Avatar' },
                      { id: 'popup', name: 'Popup' },
                    ]}
                    validate={[required('Obrigatório')]}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <SelectInput
                    fullWidth
                    label="Tipo de conteúdo vinculado"
                    source="content_name"
                    choices={[
                      { id: 'cases', name: 'Estudos de caso' },
                      { id: 'home', name: 'Home' },
                      { id: 'series', name: 'Séries' },
                      { id: 'people', name: 'Pessoas' },
                    ]}
                    validate={[required('Obrigatório')]}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <TextInput
                    fullWidth
                    label="Nome do conteúdo vinculado"
                    source="content_type"
                    validate={[required('Obrigatório'), slugValidate]}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  )
}
